angular.module('NaviaqWebApp').directive('activityLineCheckbox', [function () {
    'use strict';

    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'app/report/directives/activity-line-checkbox.html',
        link: function (scope, element, attrs) {
        }
    };
}]);
